import React, { useState } from 'react'
import Logo from "../../assets/images/auth-logo.png";
import { Card, Flex, Image, Typography } from 'antd';
import CustomButton from '../../components/CustomButton/Button';
import InvestorIcon from '../../assets/icons/investorIcon.svg'
import VendorIcon from '../../assets/icons/vendorIcon.svg'
import { useNavigate } from 'react-router-dom';
import './Signup.scss'
import { BTN_TXT, DESC_TXT, TITLE_TXT } from '../../constants/constants';

const { Title } = Typography

const SignupAs = () => {

    const [selectedCard, setSelectedCard] = useState(null);
    const navigate = useNavigate();

    const handleCardSelect = (type) => {
        setSelectedCard(type);
    };

    const isSelected = (type) => selectedCard === type;


    return (
        <div className='auth-container'>

            <div className="logo">
                <Image preview={false} src={Logo} alt="Logo" />
            </div>

            <Title className="signup-as-text">
                {TITLE_TXT.SIGNUP_AS_TITLE}
            </Title>

            <Flex vertical gap="large" className='signup-type-cards-container'>
                <Card
                    className={`signup-type-card ${isSelected('investor') ? 'selected' : ''}`}
                    onClick={() => handleCardSelect('investor')}
                >
                    <Flex gap="large" align='center'>
                        <Image src={InvestorIcon} className='icon' preview={false} alt='Investor' />
                        <Flex vertical>
                            <Title level={4}>{TITLE_TXT.INV}</Title>
                            <Typography>{DESC_TXT.INV_DESC}</Typography>
                        </Flex>
                    </Flex>
                </Card>
                <Card
                    className={`signup-type-card ${isSelected('vendor') ? 'selected' : ''}`}
                    onClick={() => handleCardSelect('vendor')}
                >
                    <Flex gap="large" align='center'>
                        <Image src={VendorIcon} className='icon' preview={false} alt='Vendor' />
                        <Flex vertical>
                            <Title level={4}>{TITLE_TXT.VEN}</Title>
                            <Typography>{DESC_TXT.VEN_DESC}</Typography>
                        </Flex>
                    </Flex>
                </Card>
            </Flex>

            <CustomButton type="primary" block disabled={!selectedCard} onClick={() => navigate('/enroll-as')}>
                {BTN_TXT.NEXT}
            </CustomButton>

        </div>
    )
}

export default SignupAs